import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import qs from 'qs'
import { appConfig } from '@/configs/config'

Vue.use(VueAxios, axios)

/******************************************/
/* REPORTS
/******************************************/

export const retrieveReports = () => {
  const url = appConfig.apiUrl + '/reports'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

export const addReport = ({ data }) => {
  const url = appConfig.apiUrl + '/reports'
  return Vue.axios.post(url, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

export const editReport = ({ id, data }) => {
  const url = appConfig.apiUrl + '/reports/' + id
  return Vue.axios.post(url, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

export const deleteReport = ({ id }) => {
  const url = appConfig.apiUrl + '/reports/' + id
  return Vue.axios.delete(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* SUPPLIERS
/******************************************/

export const retrieveSuppliers = () => {
  const url = appConfig.apiUrl + '/reports/suppliers'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* PORTALS
/******************************************/

export const retrievePortals = () => {
  const url = appConfig.apiUrl + '/reports/portals'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* TARGETS
/******************************************/

export const retrieveTargets = () => {
  const url = appConfig.apiUrl + '/reports/targets'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* SERVICES
/******************************************/

export const retrieveServices = () => {
  const url = appConfig.apiUrl + '/reports/services'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* PRODUCTS
/******************************************/

export const retrieveProducts = () => {
  const url = appConfig.apiUrl + '/reports/products'
  return Vue.axios.get(url)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error))
}

/******************************************/
/* USERS
/******************************************/

export const signIn = ({ username, password }) => {
  const url = appConfig.apiUrl + '/token'
  const data = {
    username,
    password,
    grant_type: 'password',
    client_id: 'Plain'
  }
  return Vue.axios.post(url, data)
    .then(response => { return Promise.resolve(response.data) })
    .catch(error => Promise.reject(error))
}

export const setAuthParams = ({ accessToken }) => {
  Vue.axios.defaults.params = Vue.axios.defaults.params || {}
  Vue.axios.defaults.params['access_token'] = accessToken
}

export const setInterceptors = ({ logoutCallback }) => {
  axios.interceptors.request.use(config => {
    if (
      (config.method === 'post' && config.url === appConfig.apiUrl + '/reports') ||
      (config.method === 'post' && config.url.indexOf(appConfig.apiUrl + '/reports/') !== -1)
    ) {
      return config
    }
    // config.paramsSerializer = params => qs.stringify(params)
    // obsluga Form Data zamiast Reuest Payload
    config.data = qs.stringify(config.data)
    return config
  })
  axios.interceptors.response.use(response => {
    return Promise.resolve(response)
  }, error => {
    if (typeof process.browser === 'undefined' || !process.browser) {
      return Promise.reject(error.response.data)
    }
    if (error.response && error.response.data && error.response.data.error && error.response.data.error == 'invalid_token') {
      logoutCallback()
    }
    return Promise.reject(error)
  })
}
